module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerThinItalic.0e60250f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerThinItalic.otf
// module id = 1073
// module chunks = 0